import { Directive, ElementRef } from '@angular/core';
import { ListFilterService } from '../list-filter.service';

@Directive({
    selector: '[nsFilterHighlighter]'
})
export class FilterHighlighterDirective {

    constructor(
        private listFilterService: ListFilterService,
        private element: ElementRef
    ) {
        if (this.listFilterService.searchTerm) {
            this.filter(this.listFilterService.searchTerm);
        }
        this.listFilterService.searchTerm$.subscribe(data => {
            this.filter(data);
        });
    }

    private filter(term) {
        this.stripTags(this.element.nativeElement.innerHTML);
        let html = this.element.nativeElement.innerHTML;

        if (term) {
            const regex = new RegExp(term, 'gi');
            let myArray;
            let results = [];
            let resultString = '';

            while ((myArray = regex.exec(html)) !== null) {
                results.push(myArray);
            }

            if (results.length) {
                if (results[0].index === 0) {
                    resultString = '<b>' + results[0][0] + '</b>';
                } else {
                    resultString = html.substring(0, results[0].index) + '<b>' + results[0][0] + '</b>';
                }

                for (let i = 1; i < results.length; i++) {
                    let startIndex = results[i - 1].index + results[i - 1][0].length;
                    resultString += html.substring(startIndex, results[i].index);
                    resultString += '<b>' + results[i][0] + '</b>';
                }

                let lastStartIndex = results[results.length - 1].index + results[results.length - 1][0].length;
                resultString += html.substring(lastStartIndex);

                this.element.nativeElement.innerHTML = resultString;
            } else {
                this.stripTags(html);
            }
        } else {
            this.stripTags(html);
        }
    }

    private stripTags(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.element.nativeElement.innerHTML = doc.body.textContent;
    }

}
